import React, { useEffect, useState } from 'react'
import { Popover } from 'antd'
import { useJourneyContext } from '../../context'
import { getJourneyDisplayItemType } from '../../../../_utils/journeys'
import { AddStepType, JourneyNode } from '../../types/journey-nodes'
import { JourneyAction } from '../../types/journey-context'
import { AddStepPanel } from '../../edge-types/custom-edge/add-step-panel'
import { JourneyBuilderMode } from '../../enums'
import { useAddStepOptions } from '../../hooks/use-add-step-options'

interface PlaceholderReplacementPickerProps {
    node: JourneyNode
    children: React.ReactElement
}

export const PlaceholderReplacementPicker = ({ node, children }: PlaceholderReplacementPickerProps) => {
    const [state, dispatch] = useJourneyContext()
    const [open, setOpen] = useState(false)
    const options = useAddStepOptions(node.id)

    // Watch for close popover signal
    useEffect(() => {
        if (state.closePopoversSignal > 0) {
            setOpen(false)
        }
    }, [state.closePopoversSignal])

    const handleSelect = (stepType: AddStepType) => {
        setOpen(false)
        dispatch({
            action: JourneyAction.ON_PLACEHOLDER_REPLACE,
            data: { node, stepType },
        })
    }

    if (state.mode === JourneyBuilderMode.READONLY) {
        return <>{children}</>
    }

    return (
        <Popover
            open={open}
            onOpenChange={setOpen}
            trigger="click"
            placement="rightTop"
            align={{ offset: [0, -10] }}
            destroyTooltipOnHide
            content={
                <AddStepPanel
                    options={options}
                    onSelect={handleSelect}
                    itemType={getJourneyDisplayItemType(state.journey, state.domain.ecommConfig?.itemType)}
                />
            }
        >
            {children}
        </Popover>
    )
}
